import { Box, Container, Grid } from '@mui/material';
import React from 'react';
import './home.css';
import Header from '../../components/Header/Header';
import HomePageStack from '../../components/HomePageStack/HomePageStack';
import TravelCalender from '../../components/TravelCalender/TravelCalender';
import { useNavigate } from 'react-router-dom';
import UpcommingTrips from './UpcommingTrips';
import secureLocalStorage from 'react-secure-storage';

const Home = () => {
  const users = secureLocalStorage.getItem('user-info');
  let agentId = users?.uid;
  const url = `https://api-b2b.fasttracktourism.com/agent/booking/upcoming/${agentId}`;
  const url1 = `https://api-b2b.fasttracktourism.com/agent/booking/past/${agentId}`;

  return (
    <Box>
      <Header />
      <Container sx={{ mt: { xs: 12, sm: 12, md: 5, lg: 2 } }}>
        <Box>
          <Grid container columnSpacing={5}>
            <Grid item xs={12} sm={12} md={4}>
              <Box>
                <HomePageStack />
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={8}>
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '10px',
                  boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                  padding: '10px',
                }}
              >
                <TravelCalender />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Box>
        <UpcommingTrips url={url} text="Upcomming" />
        <UpcommingTrips url={url1} text="Past" />
      </Box>
    </Box>
  );
};

export default Home;
